import clsx from "clsx";
import React from "react";

export function Badge({
  children,
  srOnlyText,
  ...props
}: {
  children: number;
  srOnlyText: string;
  id?: string;
  className?: string;
}) {
  return (
    <span
      {...props}
      className={clsx(
        "badge badge-danger tw-inline-flex tw-items-center tw-justify-center",
        "tw-h-[20px] tw-w-[20px] tw-font-semibold md:tw-h-[23px] md:tw-w-[23px]",
        props.className,
      )}
    >
      {children}
      <span className="sr-only">{srOnlyText}</span>
    </span>
  );
}
